/** @format */

import {sensorName as getSensorName} from 'helpers/sensor_names';

import {formatDateToString} from 'helpers/dateHelpers';

import {DTO_DATE_FORMAT} from '../../constants/common';
import {GraphSensorCheckFromQuery} from '../../models/api';
import {SensorChecks, SensorGroupsList, SensorsList} from './types';

/**
 * Внимание! Исключает данные за текущую дату
 * @param graphSensorChecks
 */

const processDataFromQuery = (
  graphSensorChecks: ReadonlyArray<GraphSensorCheckFromQuery>,
): SensorsList => {
  const sensorsList: SensorsList = {};

  for (let i = 0; i < graphSensorChecks.length; i++) {
    const {sensorGroup, sensorName, new: newValue, fixed, old, collectedOn} = graphSensorChecks[i];
    const today = formatDateToString(new Date(), DTO_DATE_FORMAT);
    if (!sensorGroup || collectedOn === today) {
      continue;
    }

    const currentChecks: SensorChecks = {
      detailed: [
        {
          id: sensorName,
          name: getSensorName(sensorName),
          value: newValue + old,
        },
      ],
      primary: newValue + old,
      new: newValue,
      newCount: newValue > 0 ? 1 : 0,
      fixed,
      fixedCount: fixed > 0 ? 1 : 0,
    };

    if (sensorsList[collectedOn]) {
      const newChecks: SensorGroupsList = {
        ...sensorsList[collectedOn],
      };

      const collection = sensorsList[collectedOn][sensorGroup];

      if (collection) {
        newChecks[sensorGroup] = {
          detailed: [...collection.detailed, currentChecks.detailed[0]],
          primary: collection.primary + currentChecks.primary,
          new: collection.new + currentChecks.new,
          newCount: collection.newCount + currentChecks.newCount,
          fixed: collection.fixed + currentChecks.fixed,
          fixedCount: collection.fixedCount + currentChecks.fixedCount,
        };
      } else {
        newChecks[sensorGroup] = currentChecks;
      }

      sensorsList[collectedOn] = newChecks;
    } else {
      sensorsList[collectedOn] = {
        [sensorGroup]: currentChecks,
      };
    }
  }

  return sensorsList;
};

export {processDataFromQuery};
